import ArchiveMedicaidPlanModal from './ArchiveMedicaidPlanModal';

export default ArchiveMedicaidPlanModal;
